import { Controller } from "@hotwired/stimulus"

// 주문 마감까지 남은 시간. PHP index.php 의 CalcRemaining() 을 대신한다.
//
// 원본은 브라우저의 new Date() 로 마감시각을 만들어서, 보는 사람 PC 의 시간대가
// 한국이 아니면 남은 시간이 틀리게 나왔다. 여기서는 서버가 한국시각으로 계산한
// 마감 시점을 절대시각(ISO8601 + 오프셋)으로 받아 그 차이만 센다.
export default class extends Controller<HTMLElement> {
  static targets = ["output"]
  static values = { deadline: String }

  declare readonly outputTarget: HTMLElement
  declare readonly deadlineValue: string

  private timer?: number

  connect(): void {
    this.tick()
    this.timer = window.setInterval(() => this.tick(), 1000)
  }

  disconnect(): void {
    if (this.timer) window.clearInterval(this.timer)
  }

  private tick(): void {
    const deadline = Date.parse(this.deadlineValue)
    if (Number.isNaN(deadline)) {
      this.outputTarget.textContent = "–"
      return
    }

    const remaining = Math.floor((deadline - Date.now()) / 1000)
    if (remaining <= 0) {
      this.outputTarget.textContent = "마감"
      this.outputTarget.classList.add("text-slate-400")
      this.outputTarget.classList.remove("text-rose-600")
      if (this.timer) window.clearInterval(this.timer)
      return
    }

    const hours = Math.floor(remaining / 3600)
    const minutes = Math.floor((remaining % 3600) / 60)
    const seconds = remaining % 60
    this.outputTarget.textContent = `${hours}시간 ${minutes}분 ${seconds}초`
  }
}
